/**
 * [resp-img]
 * responsive images via data-resp-img-* attributes
 */
window.coma = window.coma || {};

window.coma.articleContent = (function ($, undefined) {

	// PRIVATE FUNCTIONS
	var _private = {

		init: function () {
			this.addAccordionEvents();

			// listen to mediaqueries-changed
			$(document).on('mediaqueries-changed', function (e) {
				// the new mediaquery (xs, sm, md, lg) is stored in e.message
				_private.initTariffCalculator(e.message);
				_private.adjustTableWidth();
			});
			// listen to tabs-changed
			$(document).on('tabs-changed', function () {
				_private.initTariffCalculator(window.coma.mediaqueries.getDevice());
			});

			this.addTariffCalculatorEvents();

			// initially do it once
			this.initTariffCalculator(window.coma.mediaqueries.getDevice());

			this.generateFigureGroupTrendContent();

			this.addFigureGroupEvents();

			this.adjustTableWidth();

		},
		adjustTableWidth: function () {
			var $tables = $('table');
			$.each($tables, function (i, value) {
				var $table = $(this);
				var $thead = $(this).find('thead');

				// exit if tbody is as wide as the table itself
				if ($thead.width() >= $table.width()) return true;

				var cols = $thead.find('th').length;

				$thead.find('th').css('width', ($table.width() / cols) + 'px');

			});
		},
		generateFigureGroupTrendContent: function () {
			// figure groups with data-trend-url
			var self = this;
			var $fg = $('.figure-group[data-trend-url]');

			if ($fg.length == 0) return true; // exit

			$.each($fg, function () {
				var $item = $(this);
				if ($item.data('consent')) {
					window.consentManager.subscribe($item.data('consent')).then(function () {
						enableFigureGroupTrendItem($item);
						self.addFigureGroupEvents([$item])
					});
				} else {
					enableFigureGroupTrendItem($item);
				}
			});

			function enableFigureGroupTrendItem($item) {
				var trendUrl = $item.data('trend-url');
				var trendYears = $item.data('trend-years');
				var now = new Date();
				var year = now.getFullYear();
				var $fc = $item.find('figcaption');

				for (var i = 0; i < trendYears; i++) {
					$fc.before('<a href="' + trendUrl.replace('XXXX', year - i) + '" title="' + (year - i) + '" class="lightbox"><img data-trend-img="' + i + '" src="' + trendUrl.replace('XXXX', year - i) + '" alt="" /></a>');
					$fc.append('<a data-trend-button="' + i + '" class="button" href="#">' + (year - i) + '</a>');
				}
			}
		},
		addFigureGroupEvents: function ($_fg) {
			// figure groups
			var $fg = $_fg || $('.figure-group');

			if ($fg.length == 0) return true; // exit

			$.each($fg, function () {
				// set first as active element (img and button)
				$(this).find('img').first().addClass('active');
				$(this).find('a.button').first().addClass('inverse');

				$(this).find('a.button').on('click', function (e) {
					e.preventDefault();
					var $fg = $(this).closest('.figure-group');
					// deselect active elements
					$fg.find('.active').removeClass('active');
					$fg.find('.inverse').removeClass('inverse');

					$(this).addClass('inverse');
					$fg.find('img[data-trend-img="' + $(this).data('trend-button') + '"]').addClass('active');
				})
			});
		},
		addAccordionEvents: function () {
			// open first element of contact list
			function checkOpenings() {
				$('.accordion').each(function () {
					var activated = $(this).find('li.active').length;
					if (activated > 0) {
						$(this).closest('article').find('.accordion-show-all').toggle(false);
						$(this).closest('article').find('.accordion-hide-all').toggle(true);
					} else {
						$(this).closest('article').find('.accordion-show-all').toggle(true);
						$(this).closest('article').find('.accordion-hide-all').toggle(false);
					}
				});
			}

			$('.contact-list').find('li:first').addClass('active');
			$('.accordion-show-all').on('click', function (e){
				e.preventDefault();
				let items = $(this).closest('article').find('.accordion li');
				items.toggleClass('active', true);
				items.find('.faq-toggle-button').attr('aria-expanded', 'true');
				items.find('.acc-content-inner').toggleClass('hidden', false);
				checkOpenings();
			});
			$('.accordion-hide-all').on('click', function (e){
				e.preventDefault();
				let items = $(this).closest('article').find('.accordion li');
				items.toggleClass('active', false);
				items.find('.faq-toggle-button').attr('aria-expanded', 'false');
				setTimeout(() => {
					items.forEach((item) => {
						if (item.hasClass('active')) {
							item.find('.acc-content-inner').toggleClass('hidden', false);
						} else {
							item.find('.acc-content-inner').toggleClass('hidden', true);
						}
					})
				}, 500);
				checkOpenings();
			});
			$('.accordion').find('.acc-toggle').on('click', function (e) {
				e.preventDefault();
				let item = $(this).closest('li');
				item.toggleClass('active');
				if (item.hasClass('active')) {
					item.find('.faq-toggle-button').attr('aria-expanded', 'true');
					item.find('.acc-content-inner').toggleClass('hidden', false);
				} else {
					item.find('.faq-toggle-button').attr('aria-expanded', 'false');
				}
				setTimeout(() => {
					if (item.hasClass('active')) {
						item.find('.acc-content-inner').toggleClass('hidden', false);
					} else {
						item.find('.acc-content-inner').toggleClass('hidden', true);
					}
				}, 500);
				$('.acc-toggle-remote').toggleClass('active');
				checkOpenings();
			});
			//add second link for "Umweltschutzoptionen"
			$('.acc-toggle-remote').on('click', function (e) {
				e.preventDefault();
				$('.accordion').find('.acc-toggle').click();
				//$(this).toggleClass('active');
				$('.acc-toggle-remote').toggleClass('active');
				checkOpenings();
			});
			checkOpenings();
		},
		initTariffCalculator: function (mediaquery) {

			// only init tariff calculator in active (!) tab
			var $tc = $('ul.tabs li.tariff-calculator.active');
			if ($tc.length == 0) return true; // exit

			// set all divs to the same height
			var maxHeight = 0;
			var $cols = $tc.find('.step-1, .step-2, .step-3');

			if (mediaquery == 'xs' || mediaquery == 'sm') {
				$cols.height('auto');
				return true; // exit
			}

			// reset to auto height before calculation
			$cols.height('auto');

			// wait 200 ms so the new height value can take effect
			setTimeout(function () {
				// get the height of the highest column
				$cols.each(function () {
					maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
				});

				// make all columns same height
				$cols.height(maxHeight);
			}, 200);

			window.coma.tabs.setAllActiveHeights();
		},
		addTariffCalculatorEvents: function () {
			var $tc = $('.tariff-calculator');
			$.each($tc, function () {
				var $this = $(this),
					$label = $this.find('.headline-vs-input');
				_private.addSliderEvents($(this));
				_private.addAdditionalOfferEvents($(this));

				// add click event to toggle between headline-vs-input
				$label.on('click', function () {
					$(this).hide().parent().find('input').width($(this).width()).removeClass('hidden').focus().select();
				});

				// trigger input overlay toggle when changing value of slider
				$this.find('.tariff-slider').on('mousedown', function () {
					$label.trigger('click');
				});

				// enable tabbing
				$this.find('.step-1 input').on('keydown', function (e) {
					var keyCode = e.keyCode || e.which;
					if (keyCode == 9) {
						e.preventDefault();
						$label.trigger('click');
					}
				});

				if ($this.is('.oil')) {
					var that = $(this);
					$(this).find('.slider .grab').on('mousedown', function () {
						that.find('.step-2 .headline-vs-input').click();
					});
				}
			});

			// Electricity calculator household size buttons
			var $electricityBtns = $('.tariff-calculator.electricity .household-select-wrapper > a');
			var $electricityForm = $('#electricity-tc-slider-value-percentage');
			var householdUsage = [2000, 3500, 4250, 5000];

			$electricityBtns.on('click', function () {
				var $this = $(this);
				persons = $this.index();
				var usage = householdUsage[persons];

				$electricityBtns.removeClass('selected');
				$(this).addClass('selected');
				$electricityForm.val(usage);
			});

			// set appropriate household size on manual entry
			$electricityForm.on('blur', function () {
				$electricityBtns.removeClass('selected');
				var household = 0;
				var $formVal = Number($electricityForm.val());
				for (var i = 0; i < householdUsage.length; i++) {
					if ($formVal > householdUsage[i]) {
						household++;
					}
				}
				if (!(household > householdUsage.length)) {
					$electricityBtns.eq(household).addClass('selected');
				}
			});
		},
		addSliderEvents: function ($tc) {
			var $slider = $tc.find('div.slider');
			if ($slider.length == 0) return true; // exit

			var $progress = $slider.find('.progress');
			var $grab = $slider.find('.grab');
			var $form = $slider.closest('form');
			var $input_percentage = $form.find('input.slider-value-percentage');
			var $input_steps = $form.find('input.slider-value-steps');
			var drag;

			// TODO: init: default-werte in eingabefelder schreiben

			$grab.on('mousedown touchstart', function (e) {
				e.preventDefault();
				drag = true;
			});

			var input_percentage_min = parseInt($input_percentage.data('min'));
			var input_percentage_range = $input_percentage.data('max') - input_percentage_min;
			if ($input_steps.length != 0) var input_steps_values = $input_steps.data('steps').split(',');

			// set slider start position of the slider for the initial $input_percentage.val()
			$progress.css({'width': Math.floor($input_percentage.val() * 100 / $input_percentage.data('max')) + '%'});

			$(document).on({
				'mousemove touchmove': function (e) {
					if (drag) {
						e.preventDefault();
						e = (e.originalEvent.touches) ? e.originalEvent.touches[0] : e;

						var max = $slider.width();
						var width = e.pageX - $slider.offset().left;
						var percent = (width / max) * 100;

						if (percent < 0) percent = 0;
						if (percent > 100) percent = 100;

						$progress.css({'width': percent + '%'});

						// set input_percentage value
						if ($input_percentage.attr('data-stepped')) {
							// new stepped based calculation via .slider-value-percentage[data-stepped], .slider-value-percentage[data-stepped-count] and .slider-value-percentage[data-stepped-base]
							var input_percentage_val = input_percentage_min + $input_percentage.data('stepped-base') * Math.ceil($input_percentage.data('stepped-count') * percent / 100);
							$input_percentage.val(input_percentage_val);

							// set input_steps value
							$input_steps.val(input_percentage_val / $input_percentage.data('stepped-base') * 10);
						}
						else {
							// default calculation based on .slider-value-percentage[data-min], .slider-value-percentage[data-max] and .slider-value-steps[data-steps]
							var input_percentage_val = input_percentage_min + Math.ceil(input_percentage_range * percent / 100);
							$input_percentage.val(input_percentage_val);

							// set input_steps value
							if (typeof input_steps_values != 'undefined') {
								for (var i = 0; i < input_steps_values.length; i++) {
									if (input_percentage_val >= input_steps_values[i].split('>')[0]) {
										$input_steps.val(input_steps_values[i].split('>')[1]);
									}
								}
							}
						}
					}
				},
				'mouseup touchend': function () {
					if (drag) {
						drag = false;

					}
				}
			});
		},
		addAdditionalOfferEvents: function ($tc) {
			var $additional_offer_radiobuttons = $tc.find('input[name="additional-offer"]');
			if ($additional_offer_radiobuttons.length == 0) return true; // exit
			$($additional_offer_radiobuttons).closest('div').find('div.tariff-additional-toggle').css('visibility', 'hidden').hide();

			$additional_offer_radiobuttons.prop('checked', false).on('change', function () {
				if ($(this).val() == 1) {
					// true
					$(this).closest('div').find('div.tariff-additional-toggle').css('visibility', 'visible').fadeIn('slow');
				}
				else {
					// false
					$(this).closest('div').find('div.tariff-additional-toggle').css('visibility', 'hidden').hide();
				}

				// labels like toggle-buttons
				$(this).parent().find('label.toggle-button').removeClass('inverse');
				$(this).parent().find('label[for="' + $(this).attr('id') + '"]').addClass('inverse');


				$(document).trigger({
					type: 'tabs-changed'
				});

			});
		}
	}

	// CALL INIT
	$(document).ready(function () {
		_private.init();
	});

	// PUBLIC FUNCTIONS
	return {
		addAccordionEvents: _private.addAccordionEvents
	}

}(jQuery));